import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import { SITE_ORIGIN } from 'constants/site';

function RecipeRoundupJsonLd(props) {
  const { recipes } = props;
  if (recipes.length === 0) {
    return null;
  }
  return (
    <script
      id="roundupJsonLd"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: recipes
            .map((recipe, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              url: recipe.url
            }))
            .filter(recipe => recipe.url.includes(SITE_ORIGIN))
        })
      }}
    />
  );
}

RecipeRoundupJsonLd.propTypes = {
  recipes: arrayOf(
    shape({
      title: string,
      imageUrl: string,
      description: string,
      url: string
    })
  ).isRequired
};

export default RecipeRoundupJsonLd;
